import React, { FC, useEffect, useState } from "react";
import SettingsFormInfo from "../../shared/settingsFormInfo";
import { ExtractAccountData, ExtractAccountDataRequest } from "../../../../../models/extractAccountDataPatterns";
import { ResponseData } from "../../../../../models";
import { putSetting } from "../../../../../services/put.data.service";
import { postSetting } from "../../../../../services/post.data.service";
import SettingsTitle from "../../shared/settingsTitle";
import TextInput from "../../shared/fields/textInput";
import ToggleInput from "../../shared/fields/toggleInput";
import { Redirect } from "react-router-dom";

type Props = {
  existingExtractAccountData?: ExtractAccountData;
  isDuplicate: (value: string)=> boolean;
  load: ()=>void;
}

const ExtractAccountDataPatternsForm: FC<Props> = ({ existingExtractAccountData, isDuplicate, load }) => { 
  
  const [redirect, setRedirect] = useState<boolean>(false);
  const [platform, setPlatform] = useState<string>("");
  const [accountNumberPattern, setAccountNumberPattern] = useState<string>("");
  const [isAccountNumberCaseSensitive, setIsAccountNumberCaseSensitive] = useState<boolean>(false);
  const [workIdPattern, setWorkIdPattern] = useState<string>("");
  const [isWorkIdCaseSensitive, setIsWorkIdCaseSensitive] = useState<boolean>(false);
  const [productCodePattern, setProductCodePattern] = useState<string>("");
  const [isProductCodeCaseSensitive, setIsProductCodeCaseSensitive] = useState<boolean>(false);
  
  const [errors, setErrors] = useState<string[]>([]);


  useEffect(() => {
    if (existingExtractAccountData) {
      setPlatform(existingExtractAccountData.platform);
      setAccountNumberPattern(existingExtractAccountData.accountNumberPattern);
      setIsAccountNumberCaseSensitive(existingExtractAccountData.isAccountNumberCaseSensitive);
      setWorkIdPattern(existingExtractAccountData.workIdPattern);
      setIsWorkIdCaseSensitive(existingExtractAccountData.isWorkIdCaseSensitive);
      setProductCodePattern(existingExtractAccountData.productCodePattern);
      setIsProductCodeCaseSensitive(existingExtractAccountData.isProductCodeCaseSensitive);
    }
  }, [existingExtractAccountData]);

  const validate = (): string[] => {
    const errorMessages: string[] = [];
    if (platform.trim() === "") {
      errorMessages.push("Platform is required")
    } else if (isDuplicate(platform.trim())) {
      errorMessages.push("Platform has already been used");      
    }
    return errorMessages;
  };

  const save = (): void => {
    const errorMessages = validate();
    setErrors(errorMessages);
    if (!errorMessages.length) {
      const toSave: ExtractAccountDataRequest = {
        platform: platform.trim(),
        accountNumberPattern: accountNumberPattern.trim(),
        isAccountNumberCaseSensitive,
        workIdPattern: workIdPattern.trim(),
        isWorkIdCaseSensitive,
        productCodePattern: productCodePattern.trim(),
        isProductCodeCaseSensitive,
      };
      if (existingExtractAccountData) {
        putSetting<ExtractAccountDataRequest>("actionextractaccountdata", existingExtractAccountData.actionExtractAccountDataId, toSave)
        .then((result: ResponseData<ExtractAccountDataRequest>) => {
          if (result.success) {
            load();
            setRedirect(true);
          } else {
            setErrors([`Failed to update. ${result.message || result}`]);
          }
        });
      } else {
        postSetting<ExtractAccountDataRequest>("actionextractaccountdata", toSave)
        .then((result: ResponseData<ExtractAccountDataRequest>) => {
          if (result.success) {
            load();
            setRedirect(true);
          } else {
            setErrors([`Failed to update. ${result.message || result}`]);
          }
        });
      }
    }
  };

  if (redirect) return <Redirect to="/system-settings/accountdataextractions/list" />;

  return (
    <>
      <SettingsTitle errors={errors} title={existingExtractAccountData ? "Edit Account Data Extraction" : "Create Account Data Extraction"}>
        <button className="btn btn-primary float-right" onClick={save}>
          Save
        </button>
      </SettingsTitle>
      <div className="row">
        <SettingsFormInfo existingTitle={existingExtractAccountData?.platform} />
        <div className="col-sm-7">
          <div className="content-container p-3">
            <TextInput
              disabled={!!existingExtractAccountData}
              label="Platform" 
              name="platform" 
              onChange={setPlatform} 
              value={platform} 
            />
            <TextInput
              label="Account Number Pattern" 
              name="account-number-pattern"
              onChange={setAccountNumberPattern}
              value={accountNumberPattern}
            />
            <ToggleInput
              label="Is Account Number Case Sensitive"
              name="is-account-number-case-sensitive"
              onChange={setIsAccountNumberCaseSensitive}
              value={isAccountNumberCaseSensitive}
            />
            <TextInput
              label="Work ID Pattern" 
              name="work-id-pattern"
              onChange={setWorkIdPattern}
              value={workIdPattern}
            />
            <ToggleInput
              label="Is Work ID Case Sensitive"
              name="is-work-id-case-sensitive"  
              onChange={setIsWorkIdCaseSensitive}
              value={isWorkIdCaseSensitive}
            />
            <TextInput
              label="Product Code Pattern"
              name="product-code-pattern"
              onChange={setProductCodePattern}
              value={productCodePattern}
            />
            <ToggleInput
              label="Is Product Code Case Sensitive"
              name="is-product-code-case-sensitive"  
              onChange={setIsProductCodeCaseSensitive}
              value={isProductCodeCaseSensitive}
            />
          </div>
        </div>
      </div>
    </>

  );
};
export default ExtractAccountDataPatternsForm;
